/*
 * Editorial hero — background image rotation (crossfade).
 * Cycles [data-hero-slide] layers behind the headline/CTA text. A slide with
 * data-hero-text="false" hides the text while it shows (image-only), and its
 * data-hero-link sets where the whole image links in that state.
 * Respects prefers-reduced-motion (no auto-advance; dots still work),
 * pauses on hover/focus and when the tab is hidden.
 */
(function () {
  'use strict';

  function initHero(hero) {
    if (hero.__heroInit) return;
    hero.__heroInit = true;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    var dots   = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    if (slides.length < 2) return;

    var interval = parseInt(hero.getAttribute('data-hero-interval'), 10) || 6000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    var imageLink = hero.querySelector('[data-hero-image-link]');

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      var slide = slides[current];
      var link = slide.getAttribute('data-hero-link') || '';
      hero.classList.toggle('editorial-hero--image-only', slide.getAttribute('data-hero-text') === 'false');
      hero.classList.toggle('editorial-hero--no-link', link === '');
      if (imageLink && link) imageLink.setAttribute('href', link);
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
        d.setAttribute('aria-selected', idx === current ? 'true' : 'false');
      });
    }

    function next() { show(current + 1); }

    function start() {
      if (reduce || timer) return;
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        show(idx);
        stop();
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    show(0);
    start();
  }

  function init() {
    var heroes = document.querySelectorAll('[data-hero][data-hero-rotate]');
    Array.prototype.forEach.call(heroes, initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
